<template>
  <div class="registration-page">
    <template v-if="!user">
      <ModalCard v-if="signup" title="Регистрация" ref="signup">
        <Signup show-signin @to-signin="showSignin" />
      </ModalCard>

      <ModalCard v-if="signin" title="Авторизация" ref="signin">
        <Signin show-signup @to-signup="showSignup" />
      </ModalCard>
    </template>

    <template v-else>
      <ModalCard v-if="!hasTeam" title="Создание команды">
        <TeamCreation />
      </ModalCard>
      <div v-else class="container">
        <ContentBlock class="registration-page__text" paddings>
          Ваша команда была успешно создана. Для редактирования команды,
          пройдите по ссылке:
          <a href="http://redbullshlemkragi.ru/profile"
            >http://redbullshlemkragi.ru/profile</a
          >
        </ContentBlock>
      </div>
    </template>
  </div>
</template>

<script>
import { ModalCard } from "@/components/ui/modal/";
import Signup from "@/components/profile/auth/Signup";
import Signin from "@/components/profile/auth/Signin";
import TeamCreation from "@/components/teams/TeamCreation";
import { mapGetters } from "vuex";

export default {
  name: "Registration",
  components: {
    ModalCard,
    Signup,
    Signin,
    TeamCreation
  },
  data: () => ({
    signup: true,
    signin: false
  }),
  computed: {
    ...mapGetters("auth", ["user"]),
    hasTeam() {
      return this.user && !!this.user.team_id;
    }
  },
  methods: {
    showSignin() {
      this.signup = false;
      this.signin = true;
      this.$nextTick(() => {
        this.$refs.signin.$el.scrollIntoView();
      });
    },
    showSignup() {
      this.signup = true;
      this.signin = false;
      this.$nextTick(() => {
        this.$refs.signup.$el.scrollIntoView();
      });
    }
  }
};
</script>

<style lang="scss">
.registration-page {
  padding: 0 15px;

  &__text {
    text-align: center;
    font-size: 18px;
  }
}
</style>
